import React from 'react';

import VideoEmbed from '../UseCaseComponents/VideoEmbed';
import TextSection from '../UseCaseComponents/TextSection';
import ImageSection from '../UseCaseComponents/ImageSection';

const VideoStarterLayout = ({ useCase }) => {
  const { video, text, photo } = useCase.components;

  return (
    <div className="mt-8 w-full max-w-5xl">

      <div className="mb-8 grid grid-cols-1 gap-6 items-center sm:grid-cols-2 sm:gap-8">

        <TextSection
          heading={text?.heading}
          body={text?.body}
        />

        <ImageSection
          src={photo?.src}
          alt={photo?.alt}
          className="w-full rounded-xl object-cover"
        />

      </div>

      <VideoEmbed
        url={video?.url}
        title={useCase.title}
        className="w-full rounded-xl"
      />

    </div>
  );
};

export default VideoStarterLayout;